import { withInstall } from '@xzx-design/utils'
import _Field from './src/field'

export const Field = withInstall(_Field)
export default Field

export * from './src/field'
export * from './src/types'
